module.exports = __webpack_public_path__ + "img/grunge_tools_3.519ff646.jpg";